import { useSearchApi } from '@aibees/elephant/hooks/use-search-api';
import { useSearchTableTabs } from '@aibees/elephant/hooks/use-search-table-tabs';
import { Icon } from '@aibees/shared/components';
import { classnames, fHumanReadableNumber } from '@aibees/shared/utils';
import { memo } from 'react';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchTotalTabsProps as Props } from './types';

export const SearchTotalTabs = memo(({ className }: Props) => {
  const { api } = useSearchApi();
  const { tab, handleChangeTab } = useSearchTableTabs();

  return (
    <Styled.Wrapper
      className={classnames('SearchTotalTabs', className)}
      sx={SX.root}
      textColor="primary"
      indicatorColor="primary"
      value={tab}
      onChange={handleChangeTab}
      variant="standard"
      key={tab}
      size="medium"
    >
      {config.map(({ label, value, key }) => (
        <Styled.Tab
          LabelContent={
            api.isLoading ? (
              <Icon name="loading-right-outline" />
            ) : (
              fHumanReadableNumber(
                api?.data?.elements?.[key as keyof typeof api.data.elements]
              )
            )
          }
          LabelVariant="soft"
          key={value}
          label={label}
          value={value}
        />
      ))}
    </Styled.Wrapper>
  );
});

SearchTotalTabs.displayName = 'SearchTotalTabs';

// <Typography sx={SX.value(tab === value)} variant="body3">
//   {fHumanReadableNumber(
//     api?.data?.elements?.[key as keyof typeof api.data.elements]
//   )}
// </Typography>
